// FROM: https://github.com/modusign/modusign-client/blob/2ecd9eda9c0a4f5d7686d0dee8e8f0b8a016b23f/app/src/libs/field-font-family/index.js

import { FontType } from '@modusign/react-signing/types';

/**
 * @description - CSS @font-face에 정의되어 있는 font-family를 반환합니다.
 * @param {string} type - 폰트 종류
 */
export default function getFontFaceFontFamily(type: FontType) {
  if (!type || typeof type !== 'string') throw new TypeError();

  // 다국어 지원이 필요할 경우 Subset을 이용하던 기존의 시스템에서 변경이 필요합니다.
  const map: Record<FontType, string> = {
    NOTO_SANS: 'Noto Sans Text Field',
    NOTO_SERIF: 'Noto Serif Text Field',
  };

  const fontFamily = map[type];
  if (!fontFamily) throw new Error('Matched font-family not exist');

  return fontFamily;
}
